import { WordstatTaskState } from './state';
import { apiUrl } from '@/env';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';
import { IWordstatTask, IWordstatOneTaskStat, IWordstatTasksStatData } from '@/interfaces/wordstat';


export const mutations = {
  setWordstatTasks(state: WordstatTaskState, payload: IWordstatTask[]) {
    // добавляем флаг isExporting; его пока нет в PG
    // если isExporting = true, иконка загрузки файлов заблокирована
    payload.forEach((item) => {
      item.isExporting = state.tasks.find((task) => task.id === item.id)?.isExporting;
      item.isDownloading = state.tasks.find((task) => task.id === item.id)?.isDownloading;
      if (item.status === 'ACTIVE') {
        const taskActive = state.tasks.find((t) => t.id === item.id);
        if (taskActive && taskActive.stats) item.stats = taskActive.stats;
      }
      if (item.isExporting) item.status = 'EXPORT';
      else if (item.isDownloading) item.status = 'DOWNLOAD';
    });
    state.tasks = payload;
  },
  setWordstatTask(state: WordstatTaskState, payload: IWordstatTask) {

    // const newList: IWordstatTask[] = state.yt_tasks.slice();
    // const index = newList.findIndex(item => item.id === payload.id);
    // if (index !== -1) {
    //     newList[index] = payload;
    //     state.yt_tasks = newList;
    // };

    // самый быстрый вариант
    const newList: IWordstatTask[] = state.tasks.slice();
    for (let i = 0; i < newList.length; i++)
      if (newList[i].id === payload.id) {
        newList[i] = payload;
        break;
      }
    state.tasks = newList;
  },

  // изменяем флаг isExporting
  setWordstatTaskIsExporting(state: WordstatTaskState, payload: { id: number, isExporting: boolean}) {
      const task = state.tasks.find((item: IWordstatTask) => item.id === payload.id);
      if (task) task.isExporting = payload.isExporting;
  },

  // изменяем флаг isDownloading
  setWordstatTaskIsDownloading(state: WordstatTaskState, payload: { id: number, isDownloading: boolean}) {
      const task = state.tasks.find((item: IWordstatTask) => item.id === payload.id);
      if (task) task.isDownloading = payload.isDownloading;
  },

  setWordstatTaskStatus(state: WordstatTaskState, payload: { id: number, status: string}) {
      const task = state.tasks.find((item: IWordstatTask) => item.id === payload.id);
      if (task) task.status = payload.status;
  },

  setWordstatTasksStat(state: WordstatTaskState, payload: IWordstatTasksStatData) {
    if (payload.tasks)
      state.tasks = state.tasks.map((t: IWordstatTask) => {
        const taskStat = payload.tasks.find((s: IWordstatOneTaskStat) =>  t.id === s.task_id);
        if (taskStat) {
          t.status = taskStat.status;
          t.datetime_end = taskStat.datetime_end;

          const prev = t.stats?.prev;
          const prev_time = t.stats?.prev_time;

          t.stats = taskStat.stats;

          // записыаем стартовые значения количества найденных данных и времени
          // для расчета времени до завершения парсинга
          if (t.stats) {
            t.stats.prev = prev;
            t.stats.prev_time = prev_time;

            const curTime = new Date();

            if (t.stats.found_count > 0) {
              if (t.stats.prev === undefined)
                t.stats.prev = t.stats.found_count;

              if (t.stats.prev_time === undefined)
                t.stats.prev_time = curTime;
            }
          }

          if (taskStat.result)
            t.result = `${apiUrl}/api/v1/plugs-checker-tasks/result/${taskStat.result}`;
        }
        return t;
      });
  },
};

const { commit } = getStoreAccessors<WordstatTaskState, State>('');

export const commitSetWordstatTask = commit(mutations.setWordstatTask);
export const commitSetWordstatTasks = commit(mutations.setWordstatTasks);
export const commitSetWordstatTasksStat = commit(mutations.setWordstatTasksStat);
export const commitSetWordstatTaskIsExporting = commit(mutations.setWordstatTaskIsExporting);
export const commitSetWordstatTaskIsDownloading = commit(mutations.setWordstatTaskIsDownloading);
export const commitSetWordstatTaskStatus = commit(mutations.setWordstatTaskStatus);
